export default "static/media/virtualmeet.9fda8b5.svg"